import React from 'react';

import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideSecurityAdmin: React.FC = () => {
  return (
    <GuidePageLayout
      title="セキュリティチェックを管理する（管理者）"
      description="セキュリティチェックの開始・実施状況確認・リマインド送信を行います。"
      breadcrumbs={[{ label: 'セキュリティチェック', path: '/guide/security/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="セキュリティチェックを開始する（BUC-SC01）">
        <GuideStepList
          steps={[
            { label: 'セキュリティチェック管理画面を開く' },
            { label: '年度を選択する' },
            { label: '対象の月を選択する' },
            {
              label: '「セキュリティチェック開始」ボタンを押下する',
              content: (
                <GuideMockContainer label="開始ボタン">
                  <GuideMockButton label="セキュリティチェック開始" startIcon={<PlayArrowIcon />} />
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">セキュリティチェックは開始後に取り消せません。</GuideInfoBox>
          <GuideInfoBox type="warning">
            年度データが登録されていない月は開始できません。先に年度管理で年度データを登録してください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="実施状況を確認する（BUC-SC02）">
        <GuideStepList
          steps={[
            { label: 'セキュリティチェック管理画面を開く' },
            { label: '確認したい月を選択する' },
            {
              label: '月次タブ / PCタブで実施状況を確認する',
              description:
                '月次タブでは月次セキュリティチェックの実施状況を、PCタブではPCパッチ確認の実施状況を確認できます。',
            },
          ]}
        />
      </GuideSection>

      <GuideSection title="リマインドを送信する（BUC-SC03）">
        <GuideStepList
          steps={[
            { label: 'セキュリティチェック管理画面で実施状況を確認する' },
            { label: '未実施のユーザーにチェックを入れる' },
            {
              label: '「リマインド送信」ボタンを押下する',
              content: (
                <GuideMockContainer label="リマインドボタン">
                  <GuideMockButton
                    label="リマインド送信"
                    variant="outlined"
                    startIcon={<NotificationsActiveIcon />}
                  />
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>リマインドは未実施ユーザーに通知として送信されます。</GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideSecurityAdmin;
